export const GET_LIST_CURRENCY = 'GET_LIST_CURRENCY'
export const GET_LIST_CURRENCY_SUCCESS = 'GET_LIST_CURRENCY_SUCCESS'

export const getListCurrencySuccess = (payload) => {
    return {
        type: 'GET_LIST_CURRENCY_SUCCESS',
        payload
    }
}

export const getListCurrency = (payload) => {
    return {
        type: 'GET_LIST_CURRENCY',
        payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/getListCurrency.js